<template>
  <button
    class="b--greyhound ba bg-transparent outline-0 pointer ph4 ph5-xl pv3 warm-black"
    @click="$emit('button-activated', id)">
    <slot/>
  </button>
</template>

<script>
export default {
  name: 'AppButton',

  props: {
    id: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
button {
  position: relative;
  transition: all .3s var(--ease-cubic);
  &::before {
    border: 1px solid var(--gold);
    content: '';
    position: absolute;
    top: -6px;
    left: -6px;
    transition: all .15s var(--ease-cubic);
    width: 100%;
    height: 100%;
  }
  &:hover {
    background-color: var(--warm-black);
    color: var(--tan);
    &::before {
      border-color: transparent;
      top: 0;
      left: 0;
    }
  }
  &.is-active {
    background-color: var(--warm-black);
    color: var(--tan);
    &::before {
      border-color: transparent;
    }
  }
}
</style>
